<div class="footer-section">
    <div class="top-footer">
        <div class="main-container">
            <div class="row">
                <div class="col-3">
                    <h3>Company Information</h3>
                    <ul class="menu-link">
                        <!-- <li><a>About Us</a></li> -->
                        <li (click)="redirectToPrivacy()"><a>Privacy Policy</a></li>
                        <li (click)="redirectToTerms()"><a>Terms & Conditions</a></li>
                        <li *ngIf="profileDetail && !profileDetail?.isGuestUser" (click)="redirectToDeleteAccount()"><a>Delete Account</a></li>
                        <!-- <li><a>Recipes</a></li> -->
                    </ul>
                </div>
                <div class="col-3">
                    <h3>Quick Links</h3>
                    <ul class="menu-link">
                        <li><a (click)="openCouponPanel()">Promo Codes</a></li>
                        <li><a (click)="openLoyaltyPanel()">Wallet Rewards</a></li>
                    </ul>
                </div>
                <div class="col-3">
                    <h3>Contact Us</h3>
                    <div class="email-info">
                        <img src="assets/images/mail.svg" alt="Icon" />
                        <span>feedback@paradisefoodcourt.in</span>
                    </div>
                    <h4>Follow us on</h4>
                    <ul class="social-link">
                        <li>
                            <a href="https://www.facebook.com/ParadiseFoodCourt/" target="_blank"><img src="assets/images/facebook.svg" alt="Icon" /></a>
                        </li>
                        <li>
                            <a href="https://www.instagram.com/paradisefoodcourt/" target="_blank"><img src="assets/images/instagram.svg" alt="Icon" /></a>
                        </li>
                        <!-- <li><a><img src="assets/images/linkedin.svg" alt="Icon" /></a></li> -->
                    </ul>
                </div>
                <div class="col-3">
                    <h3>Download our app</h3>
                    <ul class="download-app">
                        <li>
                            <a href="https://play.google.com/store/apps/details?id=com.paradisebiryani.foodcourt&hl=en_IN&gl=US" target="_blank"><img src="assets/images/google_play_badge.png" alt="Google Play Store" /></a>
                        </li>
                        <li>
                            <a href="https://apps.apple.com/us/app/paradise-biryani/id1525682267" target="_blank"><img src="assets/images/apple_store_badge.png" alt="Apple Play Store" /></a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="bottom-footer">
        <div class="container">
            <p>© 2021 Paradise Food Court Pvt Ltd. All Rights Reserved.</p>
        </div>
    </div>
</div>